import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import type { ProjectFindInterface } from '@zaoblako/shared/modules/project/dto/project/project-find.dto';
import { ProjectService } from '@zaoblako/web/core/services/project/project.service';
import { StatusLabelComponent } from '@zaoblako/web/shared/components/status-label/status-label.component';
import { AutoCompleteComponent } from '@zaoblako/web/shared/dumbs/autoComplete/auto-complete/auto-complete.component';
import { HighlightMatchTextHelper } from '@zaoblako/web/shared/helpers/highlight-match-text.helper';
import { SafeHtmlPipe } from '@zaoblako/web/shared/pipes/safe-html.pipe';
import { TruncatePipe } from '@zaoblako/web/shared/pipes/truncate.pipe';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'crm-project-auto-complete',
  standalone: true,
  imports: [CommonModule, AutoCompleteComponent, StatusLabelComponent, TruncatePipe, TooltipModule, SafeHtmlPipe],
  templateUrl: './project-auto-complete.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectAutoCompleteComponent {
  @ViewChild('projectAutoComplete', { static: true }) public projectAutoComplete: AutoCompleteComponent;

  @Input() public selectedProject: ProjectFindInterface;
  @Output() public selectedProjectChange = new EventEmitter<ProjectFindInterface>();

  @Input() public projects: ProjectFindInterface[] = [];
  @Input() public participantOnly = false;
  @Input() public isError = false;

  @Input() public class: string;
  @Input() public styleClass: string | string[] | Set<string> | { [klass: string]: any };
  @Input() public inputStyle: any;
  @Input() public inputStyleClass: string;
  @Input() public placeholder: string;
  @Input() public disabled = false;
  @Input() public appendTo: string;
  @Input() public showClear = false;
  @Input() public loading = false;

  @Input() public customSearch = false;
  @Output() public projectSearch = new EventEmitter<string>();

  public constructor(
    private readonly projectService: ProjectService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public toProject(project: any): ProjectFindInterface {
    return project as ProjectFindInterface;
  }

  public searchProject(name: string) {
    this.projectService.search({ search: name, participantOnly: this.participantOnly }).subscribe((projects) => {
      this.projects = projects;
      this.cdRef.markForCheck();
    });
  }

  public highlightMatchText(text: string): string {
    return HighlightMatchTextHelper.highlightMatchText(text, this.projectAutoComplete?.autoComplete?.inputValue());
  }
}
